import { User, UserBase } from '@core/utils/models/user.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const LoginActions = createActionGroup({
  source: 'Auth Login Page',
  events: {
    Login: props<{ phoneNumber: string }>(),
    'Login Success': props<{ userBase: UserBase }>(),
    'Login Failure': props<{ error: HttpError }>(),
  },
});

export const RegisterActions = createActionGroup({
  source: 'Auth Register Page',
  events: {
    Register: props<{ phoneNumber: string; userSlug: string; }>(),
    'Register Success': props<{ userBase: UserBase }>(),
    'Register Failure': props<{ error: HttpError }>(),
  },
});

export const OtpActions = createActionGroup({
  source: 'Auth OTP Page',
  events: {
    'Submit Otp': props<{ otp: string }>(),
    'Submit Otp Success': props<{ user: User }>(),
    'Submit Otp Failure': props<{ error: HttpError }>(),
  },
});

export const UserSlugActions = createActionGroup({
  source: 'Auth Register Page',
  events: {
    'Check User Slug Availability': props<{ userSlug: string }>(),
    'Check User Slug Availability Success': props<{ isAvailable: boolean; }>(),
    'Check User Slug Availability Failure': props<{ error: HttpError }>(),
    'Clear User Slug': emptyProps()
  },
});

export const AuthResetActions = createActionGroup({
  source: 'Auth Pages',
  events: {
    'Cancel Auth Actions': emptyProps(),
    'Cancel Auth Actions Success': emptyProps(),
    'Reset Auth': emptyProps(),
  },
});
